import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-video-dialog',
  templateUrl: './video-dialog.component.html',
  styleUrls: ['./video-dialog.component.scss'],
})
export class VideoDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<VideoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public sanitizer: DomSanitizer,
  ) {}

  getVideoURL() {
    let prefix = 'https://www.youtube.com/embed/';
    let postfix =
      '?&loop=1&showinfo=0&playsinline=1&fs=1&showinfo=0&disablekb=1&autoplay=1&rel=0';
    return this.sanitizer.bypassSecurityTrustResourceUrl(
      prefix + this.data.videoId + postfix,
    );
  }
}
